import { Component, Input, SimpleChanges } from '@angular/core';
import { IRptEspCobPay } from '../../../shared/interfaces/rptEspCob';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-rpt-esp-cob-pay',
  imports: [],
  templateUrl: './rpt-esp-cob-pay.component.html',
  styleUrl: '../rpt-esp-cob.component.css',
  standalone: false
})
export class RptEspCobPayComponent {
  @Input() payments: IRptEspCobPay[];
  @Input() engLang: boolean;

  dataSource: MatTableDataSource<IRptEspCobPay> = new MatTableDataSource<IRptEspCobPay>();
  displayedColumns: string[] = [
    'payPS',
    'payedDt',
    'payMode',
    'payCkNo',
    'payApCode',
    'payAmnt'
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['payments'] && this.payments) {
      this.dataSource.data = this.payments.slice(); // Create a new array to avoid reference issues
    }
  }
}
